function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.768559mm",
    height: "7.6728292mm",
    viewBox: "0 0 5.768559 7.6728292",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.636886,-58.199764)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 33.168132,62.858963 q 0.01465,-0.595703 0.01953,-1.186523 0.0098,-0.590821 0.0098,-1.16211 v -0.74707 q -0.688476,0.874023 -1.542969,1.875 -0.849609,0.996094 -0.849609,1.09375 0,0.08789 0.107422,0.126953 0.107422,0.03418 0.395508,0.03418 0.07324,0 0.288086,-0.0049 0.219726,-0.0049 0.361328,-0.0049 0.175781,0 0.776367,-0.01465 0.27832,-0.0049 0.43457,-0.0098 z m -0.02441,0.712891 q -0.727539,0 -1.533203,-0.01465 -0.205078,-0.0049 -0.253906,-0.0049 -0.439453,0 -0.737305,0.02441 -0.292969,0.01953 -0.449219,0.06348 -0.146484,-0.161133 -0.214843,-0.307617 -0.06836,-0.146485 -0.06836,-0.302735 0,-0.419921 1.289063,-1.884765 0.610351,-0.698242 0.971679,-1.123047 0.07324,-0.09277 0.214844,-0.258789 1.09375,-1.313477 1.464844,-1.313477 0.146484,0 0.205078,0.102539 0.06348,0.09766 0.06348,0.371094 0,0.07324 -0.02441,0.419922 -0.117188,1.674805 -0.117188,3.276367 v 0.219727 q 0.361328,0 0.629883,-0.04395 0.268555,-0.04883 0.444336,-0.141601 0.06348,0.136719 0.09277,0.249023 0.03418,0.107422 0.03418,0.200196 0,0.273437 -0.175781,0.390625 -0.175782,0.117187 -0.590821,0.117187 -0.107421,0 -0.361328,-0.01465 -0.03906,-0.0049 -0.05859,-0.0049 0.0049,0.361328 0.01465,0.844726 0.01465,0.478516 0.01465,0.595704 0,0.332031 -0.09277,0.458984 -0.08789,0.131836 -0.307617,0.131836 -0.141602,0 -0.322266,-0.05859 -0.175781,-0.05859 -0.40039,-0.170898 0.131835,-0.239258 0.195312,-0.683594 0.06836,-0.449219 0.07324,-1.137695 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit4);
export default __webpack_public_path__ + "static/media/digit-4.64ccf973133ad88184d942f738c9b67a.svg";
export { ForwardRef as ReactComponent };